export default {
  path: '/none-display-product',
  component: () => import('@/views/noneDisplayProduct/index.vue'),
  children: [
    {
      path: '',
      name: 'noneDisplayProductList',
      component: () => import('@/views/noneDisplayProduct/pages/list.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'accounting_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    },
    {
      path: '/detail/:id',
      name: 'noneDisplayProductDetail',
      component: () => import('@/views/noneDisplayProduct/pages/detail.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'area_manager',
          'developer',
          'support',
          'warehouse_manager',
          'warehouse',
          'store_manager',
          'accounting_manager',
          'acting_assist_store_manager',
          'assist_store_manager',
          'sales_staff'
        ]
      }
    }
  ]
}
